
    import { Component, Vue, Prop } from "vue-property-decorator";
    @Component({})
    export default class ServicesBanner extends Vue {
        @Prop({ default: '' }) public readonly bg!: string;
        @Prop({ default: '' }) public readonly icon!: string;
         @Prop({ default: '' }) public readonly desc!: string;
        get iconSrc(): string {
            try {
                // Webpack will bundle files matched by this context require
                return require(`@/assets/images/services/${this.icon}.svg`);
            } catch (e) {
                try {
                    return require('@/assets/images/services/icon-dexid.svg');
                } catch (_) {
                    return '';
                }
            }
        }
         get bgSrc(): string {
            try {
                // Webpack will bundle files matched by this context require
                return require(`@/assets/images/services/${this.bg}.webp`);
            } catch (e) {
                try {
                    return require('@/assets/images/services/icon-dexid.svg');
                } catch (_) {
                    return '';
                }
            }
        }
    }
